import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  overflow: hidden !important;
  width: 100vw;
  height: 100vh;
`;
